"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const antd_1 = require("antd");
const elements_1 = require("@src/components/elements");
const MissingContentView_style_1 = require("./MissingContentView.style");
const MissingContentView = ({ children, heading, message, }) => {
    return ((0, jsx_runtime_1.jsxs)(elements_1.Panel, { children: [(0, jsx_runtime_1.jsx)(antd_1.Row, { justify: "center", gutter: [16, 16], children: (0, jsx_runtime_1.jsxs)(antd_1.Col, { xs: 24, md: 18, className: "text-center", children: [(0, jsx_runtime_1.jsx)(MissingContentView_style_1.StyledNoteAlertIcon, {}), heading && (0, jsx_runtime_1.jsx)(MissingContentView_style_1.CenteredHeading, { children: heading }), message && (0, jsx_runtime_1.jsx)(MissingContentView_style_1.MessageWrapper, { children: message })] }) }), (0, jsx_runtime_1.jsx)(antd_1.Row, { children: (0, jsx_runtime_1.jsx)(antd_1.Col, { xs: 24, className: "text-center", children: children }) })] }));
};
exports.default = MissingContentView;
